<template>
    <div></div>
</template>

<script>
import AuthService from '@/services/auth/AuthService';
import AuthRedirectService from '@/services/auth/AuthRedirectService';

export default {
    name: 'Logout',
    data() {
        return {
            authService: new AuthService(),
        };
    },
    mounted() {
        this.$store.dispatch('auth/logout');
        this.authService.logout();

        AuthRedirectService.redirectToLoginPage('login');
    },
};
</script>
